import { render, staticRenderFns } from "./MarkBook.vue?vue&type=template&id=1b9caaeb&scoped=true"
import script from "./MarkBook.vue?vue&type=script&lang=js"
export * from "./MarkBook.vue?vue&type=script&lang=js"
import style0 from "./MarkBook.vue?vue&type=style&index=0&id=1b9caaeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9caaeb",
  null
  
)

export default component.exports